import styles from "@/styles/Video.module.scss";
import AgeRestriction from "./AgeRestriction";
import AppKick from "./AppKick";
import DvrLive from "./DvrLive";
import EntitlementConfirm from "./EntitlementConfirm";
import LiveBefore from "./LiveBefore";
import NeedLogin from "./NeedLogin";
import NextEpisode from "./NextEpisode";
import NoEntitled from "./NoEntitled";
import OverlayError from "./OverlayError";
import ResumeSelect from "./ResumeSelect";
import SuggestApp from "./SuggestApp";
import ChatSelect from "./ChatSelect";
import { useEffect, useState } from "react";

export default function VideoOverlay({
  watch,
  state,
  error,
  poster,
  isChatAvailableMeta,
  setChatDisplay,
  isValidChatPeriod,
  chatDisplay,
}) {
  const { nextEpisode } = watch;
  const [isChatSelected, setIsChatSelected] = useState(
    !(isChatAvailableMeta && isValidChatPeriod) || chatDisplay
  );
  useEffect(() => {
    setIsChatSelected(
      !(isChatAvailableMeta && isValidChatPeriod) || chatDisplay
    );
  }, [isChatAvailableMeta, isValidChatPeriod, chatDisplay]);
  if (!state.overlay && !error) return null;
  else if (state.reason === "chat_select" && chatDisplay) {
    // チャット表示済みの場合、チャットを表示して再生するかの選択を出さないようにする
    state.updateResumePoint(0);
    return null;
  } else if (state.reason === "next_episode" && !nextEpisode) return null;

  return (
    <div className={styles.overlay}>
      {state.reason === "needlogin" && <NeedLogin watch={watch} />}
      {state.reason === "needlogin_and_contract" && (
        <NeedLogin withContract watch={watch} />
      )}
      {state.reason === "entitlement_confirm" && (
        <EntitlementConfirm state={state} />
      )}
      {state.reason === "geolocation" && (
        <OverlayError message={state.error.message} error={state.error} />
      )}
      {state.reason === "suggest_app" && (
        <SuggestApp watch={watch} state={state} />
      )}
      {state.reason === "resume" && !isChatSelected && (
        <ChatSelect
          setChatDisplay={setChatDisplay}
          setIsChatSelected={setIsChatSelected}
          reason={state.reason}
          play={false}
          state={state}
        />
      )}
      {state.reason === "resume" && isChatSelected && (
        <ResumeSelect state={state} />
      )}
      {state.reason === "live_before" && (
        <LiveBefore
          watch={watch}
          state={state}
          isChatAvailableMeta={isChatAvailableMeta}
          setChatDisplay={setChatDisplay}
        />
      )}
      {state.reason === "dvr_live" && !isChatSelected && (
        <ChatSelect
          setChatDisplay={setChatDisplay}
          setIsChatSelected={setIsChatSelected}
          reason={state.reason}
          play={false}
          state={state}
        />
      )}
      {state.reason === "dvr_live" && isChatSelected && (
        <DvrLive state={state} />
      )}
      {state.reason === "appkick" && <AppKick watch={watch} />}
      {state.reason === "rating" && <AgeRestriction watch={watch} />}
      {state.reason === "next_episode" && (
        <NextEpisode watch={watch} state={state} />
      )}
      {state.reason === "playback_error" && (
        <>
          {state.error.reason == "not_delivery_started" && (
            <OverlayError
              poster={poster}
              error={state.error}
              isChatAvailableMeta={isChatAvailableMeta}
              setChatDisplay={setChatDisplay}
            />
          )}
          {state.error.reason == "not_entitled" && <NoEntitled watch={watch} />}
          {!["not_entitled", "not_delivery_started"].includes(
            state.error.reason
          ) && (
            <OverlayError
              error={state.error}
              isChatAvailableMeta={isChatAvailableMeta}
              setChatDisplay={setChatDisplay}
            />
          )}
        </>
      )}
      {state.reason === "error" && (
        <OverlayError
          error={state.error}
          isChatAvailableMeta={isChatAvailableMeta}
          setChatDisplay={setChatDisplay}
        />
      )}
      {error && <OverlayError error={error} />}
      {state.reason === "chat_select" && (
        <ChatSelect
          setChatDisplay={setChatDisplay}
          setIsChatSelected={setIsChatSelected}
          reason={state.reason}
          play={true}
          state={state}
        />
      )}
    </div>
  );
}
